import * as React from 'react';
import './style.css';

export interface LoadFailureProps {
  className?: string;
  message?: string;
  pageUrl: string;
  title?: string;
}

export interface LoadFailureState {
  /* empty*/
}

export class LoadFailure extends React.Component<
  LoadFailureProps,
  LoadFailureState
> {
  render() {
    const { className, message, pageUrl, title } = this.props;

    return (
      <div className={`${className ? `${className} ` : ``}load-failure`}>
        <main className="load-failure-content">
          <h1>{title ? title : `Something went wrong`}</h1>
          <br />
          <section className="load-failure-message">
            <p>
              {message
                ? message
                : `Sorry, an error occurred while trying to load this data.`}
            </p>
            <br />
            <p>
              {/* NOTE: Use a *real* link here to force a page reload */}
              <a
                className="edge-of-play-link load-failure-reload-link"
                href={pageUrl}
              >
                Click here
              </a>{' '}
              to try and reload the page.
            </p>
            <p>
              If that doesn't fix the problem, then please email{' '}
              <a
                className="edge-of-play-link"
                href="mailto:admin@edgeofplay.com"
              >
                admin@edgeofplay.com
              </a>{' '}
              for further assistance.
            </p>
          </section>
        </main>
      </div>
    );
  }
}

export default LoadFailure;



// WEBPACK FOOTER //
// ./src/app/components/Common/LoadFailure/index.tsx